/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext } from "react";

export const Context = createContext<any>([[], () => {}]);
